import { api } from './client';

export interface CatalogItemDto {
  id: number;
  name: string;
  unit: string;
  unitPrice: number;
  currencyCode: string;
  vatRate: number;
  incomeAccount: number;
  expenseAccount: number;
  vatAccount: number;
  type: string;
  description: string | null;
  code: string | null;
  isObsolete: boolean;
}

export interface CreateCatalogItemRequest {
  name: string;
  unit?: string;
  unitPrice: number;
  vatRate: number;
  incomeAccount: number;
  expenseAccount: number;
  vatAccount: number;
  type?: string;
  description?: string;
  code?: string;
}

export const catalogApi = {
  list: (params: { searchText?: string; type?: string } = {}) =>
    api.get<CatalogItemDto[]>('/catalog', {
      searchText: params.searchText,
      type: params.type,
    }),

  getById: (id: number) =>
    api.get<CatalogItemDto>(`/catalog/${id}`),

  create: (data: CreateCatalogItemRequest) =>
    api.post<number>('/catalog', data),

  update: (id: number, data: CreateCatalogItemRequest & { isObsolete?: boolean }) =>
    api.put<void>(`/catalog/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/catalog/${id}`),
};
